import { Component, Input } from '@angular/core';
import { NewsContentPageTableSection } from 'src/app/model/section/news-content-page-table-section';

import { documentToHtmlString } from '../additional-page-table-section';

@Component({
  selector: 'app-additional-page-table-section',
  templateUrl: './additional-page-table-section.component.html',
  styleUrls: ['./additional-page-table-section.component.scss']
})
export class AdditionalPageTableSectionComponent {
  @Input() tableSections: NewsContentPageTableSection[] = [];
  constructor() {}
  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }
    return documentToHtmlString(richText);
  }
}
